export const SYNODIC = 29.530588853;
const NEW_MOON_REF = Date.UTC(2000, 0, 6, 18, 14, 0);
export const LOCALES = { fr: "fr-CH", de: "de-CH", it: "it-CH", en: "en-GB" };

export const SABBATS = [
  { key: "imbolc", m: 2, d: 1 },
  { key: "ostara", m: 3, d: 20 },
  { key: "beltane", m: 5, d: 1 },
  { key: "litha", m: 6, d: 21 },
  { key: "lughnasadh", m: 8, d: 1 },
  { key: "mabon", m: 9, d: 22 },
  { key: "samhain", m: 10, d: 31 },
  { key: "yule", m: 12, d: 21 },
];

export function moonPhase(date) {
  const days = (date.getTime() - NEW_MOON_REF) / 86400000;
  let phase = (days % SYNODIC) / SYNODIC;
  if (phase < 0) phase += 1;
  return phase;
}

export function illumination(phase) {
  return (1 - Math.cos(phase * 2 * Math.PI)) / 2;
}

export function phaseKey(phase) {
  if (phase < 0.02 || phase >= 0.98) return "moon_new";
  if (phase < 0.24) return "moon_waxing_crescent";
  if (phase < 0.26) return "moon_first_quarter";
  if (phase < 0.49) return "moon_waxing_gibbous";
  if (phase < 0.51) return "moon_full";
  if (phase < 0.74) return "moon_waning_gibbous";
  if (phase < 0.76) return "moon_last_quarter";
  return "moon_waning_crescent";
}

export function nextFullMoon(from = new Date()) {
  const p = moonPhase(from);
  return new Date(from.getTime() + (((0.5 - p) + 1) % 1) * SYNODIC * 86400000);
}

export function nextNewMoon(from = new Date()) {
  const p = moonPhase(from);
  return new Date(from.getTime() + ((1 - p) % 1) * SYNODIC * 86400000);
}

export function daysFromFullMoon(date) {
  const p = moonPhase(date);
  let d = Math.abs(p - 0.5);
  d = Math.min(d, 1 - d);
  return d * SYNODIC;
}

export function daysFromNewMoon(date) {
  const p = moonPhase(date);
  return Math.min(p, 1 - p) * SYNODIC;
}

export function isFullMoonDay(date) {
  return daysFromFullMoon(date) < 0.6;
}

export function isNewMoonDay(date) {
  return daysFromNewMoon(date) < 0.6;
}

export function isNearFullMoon(date, windowDays = 2) {
  return daysFromFullMoon(date) <= windowDays;
}

export function nextSabbat(now = new Date()) {
  return upcomingSabbats(now, 1)[0];
}

export function upcomingSabbats(now = new Date(), count = 8) {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const list = [];
  for (const y of [now.getFullYear(), now.getFullYear() + 1]) {
    for (const s of SABBATS) list.push({ key: s.key, date: new Date(y, s.m - 1, s.d) });
  }
  list.sort((a, b) => a.date - b.date);
  return list.filter((c) => c.date >= today).slice(0, count);
}

export function fmtDate(date, lang, opts) {
  return new Intl.DateTimeFormat(LOCALES[lang] || "en-GB", opts || { day: "numeric", month: "long" }).format(date);
}
